<template>
  <div class="mt-2">
    <v-card tile hover>
      <ImagesCarusel
        v-bind="carusel"
        :chunkArray="chunkImagesArray"
        @selected="onClickHandler"
        :component="imageComponent"
      ></ImagesCarusel>
      <span style="color:red; font-size:12px; text-align:center" class="ml-2">{{ errorMessages[0] }}</span>
    </v-card>
  </div>
</template>

<script>
import httpClient from '@/api/httpClient'
import IconCard from '@/components/images/IconCard'
import ImagesCarusel from '@/components/images/ImagesCarusel'
import translate from '@/utils/genTable/multilanguageHelper.js'
export default {
  data() {
    return {
      title: translate('Pick image :', 'components.iconsArea'),
      response: null,
      content: null,
      selectedImages: null,
      imageComponent: IconCard,
      imagesToPreview: []
    }
  },
  props: {
    value: Number | Array,
    errorMessages: {
      type: Array,
      required: false
    },
    caruselProps: {
      type: Object,
      required: false
    },
    imgProps: {
      type: Object,
      required: false
    },
    areaProps: {
      type: Object,
      required: false
    },
    multiple: {
      type: Boolean,
      default: function() {
        return false
      }
    }
  },
  provide: function() {
    return {
      imgProps: this.imgProps
    }
  },
  components: {
    ImagesCarusel,
    IconCard
  },
  mounted() {
    if (this.multiple) {
      this.content = []
      if (this.value) {
        this.content = this.value
      }
    }
    this.getAllImages()
  },
  methods: {
    getAllImages() {
      httpClient.get(this.areaProps.endPoint).then(response => {
        this.imagesToPreview = response.data
        this.addPathAndStatusToImgFile()
        if (this.value) {
          this.setSelectedImages(this.value)
        }
        this.makeChunkImagesArray()
      })
    },
    onClickHandler(id) {
      let selected = this.imagesToPreview.find(el => el.id == id)
      if (this.multiple) {
        if (!selected.status) {
          Object.assign(selected, { status: true })
          this.content.push(id)
        } else {
          Object.assign(selected, { status: false })
          //Brisanje iz niza
          this.content = this.content.filter(el => el !== id)
        }
        this.imagesToPreview
          .filter(e => e.id === selected.id)
          .map(el => (el = selected))
      } else {
        //SINGLE UPLOAD
        if (!selected.status) {
          selected = Object.assign({}, selected, { status: true })
          this.imagesToPreview.map(el => (el.status = false))
          this.imagesToPreview
            .filter(e => e.id == id)
            .map(el => (el.status = selected.status))
          this.content = selected.id
        } else {
          Object.assign(selected, { status: false })
          this.content = null
        }
      }
    },
    addPathAndStatusToImgFile() {
      if (this.imagesToPreview) {
        for (const img of this.imagesToPreview) {
          let path =
            process.env.VUE_APP_S3_DOMAIN +
            '/' +
            this.areaProps.endPoint +
            '/' +
            img.fileName
          Object.assign(img, { imgPath: path })
          this.$set(img, 'status', false)
        }
      }
    },
    makeChunkImagesArray: function() {
      const chunked_arr = []
      let index = 0
      while (index < this.imagesToPreview.length) {
        chunked_arr.push(
          this.imagesToPreview.slice(index, this.areaProps.chunkSize + index)
        )
        index += this.areaProps.chunkSize
      }
      return chunked_arr
    },
    setSelectedImages(selectedImagesId) {
      if (Array.isArray(selectedImagesId)) {
        selectedImagesId.forEach(x => {
          var selected = this.imagesToPreview.filter(el => el.id == x)[0]
          selected.status = true
        })
      } else {
        var selected = this.imagesToPreview.filter(
          el => el.id == selectedImagesId
        )[0]
        selected.status = true
      }
    }
  },
  computed: {
    chunkImagesArray: function() {
      if (this.imagesToPreview) {
        return this.makeChunkImagesArray()
      }
      return []
    },
    selectedImagesId: function() {
      return this.value
    },
    carusel() {
      return {
        ...this.caruselProps,
        ...{
          showArrows: true,
          showArrowsOnHover: true,
          hideDelimiters: true,
          hideDelimiterBackground: false
        }
      }
    }
  },
  watch: {
    content: {
      async handler() {
        this.$emit('input', this.content)
      }
    },
    imagesToPreview: function() {
      this.addPathAndStatusToImgFile()
      if (this.value) {
        this.setSelectedImages(this.value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
